
import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    // Use matchMedia results directly instead of window.innerWidth
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    
    // Debounced resize handler to prevent excessive updates
    let timeoutId: ReturnType<typeof setTimeout>;
    const onChange = () => {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setIsMobile(mql.matches);
      }, 100); // 100ms debounce
    }
    
    // Add event listener
    mql.addEventListener("change", onChange)
    
    // Initial check using mql.matches directly
    setIsMobile(mql.matches)
    
    // Cleanup
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      mql.removeEventListener("change", onChange)
    }
  }, [])

  return !!isMobile
}
